<template>
  <div>
    <v-overlay v-if="showLoadingForUpload">
      <v-img :src="require('@/assets/svgs/gondola2.svg')" />
      Uploading images...
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Got it!
        </v-btn>
      </template>
    </v-snackbar>
    <v-btn
      style="align-self: center; margin: 16px !important; border-radius: 12px"
      class="appbutton white--text font-weight-medium"
      color="accent"
      :v-bind="size"
      @click="itemQualityDialog = true"
      block
    >
      <v-icon x-small class="mr-1">fas fa-plus</v-icon>
      <span v-if="!reUpload" class="text-caption">
        Upload Quality check Images</span
      >
      <span v-else-if="reUpload" class="text-caption">Reupload Images</span>
    </v-btn>

    <v-dialog
      v-model="itemQualityDialog"
      dialog-bottom-transition
      persistant
      rounded
      style="border-radius: 12px !important"
      width="80vw"
      max-width="1000px"
    >
      <v-card
        style="border-radius: 12px !important; padding-bottom: 8px !important"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
            background-color: #b22af0 !important;
          "
          class="text-center black--text"
        >
          <v-icon small color="white" @click="itemQualityDialog = false"
            >mdi-close</v-icon
          >
          <h3
            class="my-3 ml-auto mr-auto"
            style="
              color: white !important;
              -webkit-hyphens: none !important;
              -moz-hyphens: none !important;
              -ms-hyphens: none !important;
              hyphens: none !important;
            "
          >
            Item Quality Assessment
            <!-- <svg
              height="20px"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="#B22AF0"
                class="fa-primary"
                d="M175 320.1c9.373 9.371 24.56 9.379 33.94 0l47.03-47.03l47.03 47.03c9.373 9.371 24.56 9.379 33.94 0c9.375-9.375 9.375-24.56 0-33.94L289.9 240l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0l-47.03 47.03L208.1 159c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L222.1 240L175 287C165.7 296.4 165.7 311.6 175 320.1z"
              />
              <path
                fill="#F8955B"
                class="fa-secondary"
                d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 49.63 21.35 94.98 56.97 130.7C44.5 421.1 2.729 465.1 2.229 466.5c-2.25 2.25-2.875 5.734-1.5 8.734C1.978 478.2 4.75 479.1 8 479.1c66.25 0 115.1-31.76 140.6-51.39c32.63 12.25 69.02 19.39 107.4 19.39c141.4 0 255.1-93.13 255.1-208S397.4 31.1 256 31.1zM336.1 287c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.379-24.56 9.371-33.94 0l-47.03-47.03l-47.03 47.03c-9.381 9.379-24.56 9.371-33.94 0c-9.375-9.375-9.375-24.56 0-33.94L222.1 240L175 192.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0l47.03 47.03l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94L289.9 240L336.1 287z"
              />
            </svg> -->
          </h3>
        </v-card-title>
        <v-divider></v-divider>

        <p
          class="my-3 ml-auto mr-auto text-center"
          style="margin: 16px !important"
        >
          For electronic items please try and show that the item is working
          (screen/lights on, etc.)
        </p>
        <p
          class="my-3 ml-auto mr-auto text-center"
          style="margin: 16px !important"
        >
          Please assess your item and provide pictures of any existing damage.
        </p>
        <p class="text-center">
          <b>Upload Item Images below (At least 1, maximum of 5 Images) </b>
        </p>

        <vue-dropzone
          id="customdropzone"
          ref="imgDropZone"
          type="file"
          accept="image/*"
          :max-number-of-files="5"
          style="border-radius: 12px !important; margin: 16px !important"
          :options="dropzoneOptions"
          @vdropzone-complete="afterComplete"
          @vdropzone-removed-file="remove"
        />

        <div style="display: flex; justify-content: center">
          <v-btn
            elevation="8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            class="ebtn ma-3"
            @click="itemQualityDialog = false"
            >Close</v-btn
          >
          <v-btn
            elevation="8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            color="primary"
            :disabled="!formIsValid"
            class="ebtn ma-3"
            type="submit"
            @click="
              submitImages();
              itemQualityDialog = false;
            "
            >Submit</v-btn
          >
        </div>
        <!-- <p class="my-3 ml-auto mr-auto text-center" style="margin: 16px !important;" >We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to give you an even better rental
              experiences in the future.</p> -->
      </v-card>
    </v-dialog>

    <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="rateSuccessDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            padding-top: 8px !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="rateSuccessDialog = false"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">Booking succesfully Declined</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p>
              <br />
              <br />

              <span class="font-weight-bold text-subtitle-1"
                >We have notified the borrower of your selection</span
              >

              <!-- We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to get you amazing rental
              experiences in the future. -->
            </p>
          </v-col>
        </v-row>
        <div class="grid">
          <v-btn
            elevation="8"
            width="7rem"
            color="secondary"
            type="submit"
            value="Save Changes"
            class="ebtn"
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
} from "firebase/storage";
const uuid = require("uuid");
export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      showLoadingForUpload: false,
      rating: 0,
      review: "",
      formIsValid: false,
      max: 500,
      itemQualityDialog: false,
      imageUrls: [],
      rateSuccessDialog: false,
      snackbar: false,
      text: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { "My-Awesome-Header": "header value" },
      },
      booking: {},
    };
  },

  props: {
    booking: {
      type: Object,
      default: null,
    },

    reUpload: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.formIsValid = false;
    console.log("booking: ", props.booking);
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "medium", lg: "medium", xl: "medium" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
  methods: {
    async afterComplete(upload) {
      console.log("set form is valid");
      this.formIsValid = true;
    },
    // uploadImageAndContinue() {
    //   this.imageUrls = [];
    //   this.e4 = 2;
    //   var files = this.$refs.imgDropZone.getAcceptedFiles();
    //   var arr = [];
    //   for (var i in files) {
    //     arr.push(files[i].dataURL);
    //   }
    //   this.imageUrls = arr;
    //   console.log('images:', this.imageUrls);
    // },
    async uploadImagesAndGetUrls() {
      return new Promise(async (resolve, reject) => {
        // const promises = [];
        var photos = [];
        for (var i in this.imageUrls) {
          var imageUrl = uuid.v1();
          try {
            // save image
            const file = this.imageUrls[i];

            const storage = getStorage();
            const imageRef = ref(
              storage,
              `bookings/${this.booking.id}/${imageUrl}.png`
            );

            const snapshot = await uploadString(imageRef, file, "data_url");
            const downloadURL = await getDownloadURL(snapshot.ref);
            photos.push({ src: downloadURL });

            console.log(photos);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(photos);
        resolve(photos);
      });
    },

    onFilePicked(event) {
      const files = event.target.files;
      for (var i = 0; i < files.length; i++) {
        const filename = files[i].name;
        if (filename.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrls.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[i]);
      }
      console.log(this.imageUrls);
    },
    onPickFile() {
      this.$refs.imgDropZone.click();
    },

    //  async afterComplete(upload) {
    //     this.uploaded++;
    //     //var imageUrl = uuid.v1();
    //     this.isLoading = true;
    //  },

    showToast(msg) {
      console.log("fire toast");
      this.snackbar = true;
      this.text = msg;
    },

    async submitImages() {
      this.showLoadingForUpload = true;
      // await this.uploadImageAndContinue();
      var images = await this.uploadImagesAndGetUrls();
      console.log(this.booking);
      await this.$store.dispatch("updateBookingData", {
        id: this.booking.id,
        QAimages: {
          images,
          uploadedAt: firebase.firestore.Timestamp.now(),
        },
        // images,
        status: "finalised",
      });
      this.showLoadingForUpload = false;
      this.$emit("refreshBooking");
      // this.$router.push('/dashboard?s=1').catch((err) => {});
    },

    rate() {
      console.log(this.booking.id);
      var bookingRef = firebase
        .firestore()
        .collection("items")
        .doc(this.booking.itemID);
      if (
        bookingRef.rating_count === null ||
        bookingRef.rating_count === undefined
      ) {
        bookingRef.rating_count = 0;
      }

      bookingRef.update({
        rating:
          (bookingRef.rating_count * bookingRef.rating + this.rating) /
          (bookingRef.rating_count + 1),
        rating_count: bookingRef.rating_count + 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropzone .dz-preview.dz-image-preview {
  background: white;
  z-index: 2;
}
</style>
